module.exports = __webpack_public_path__ + "img/home-page-girl-heart-min.1e4bf289.jpg";